import {Buffer} from 'buffer'

type JwtBody = {
    type: 'access' | 'refresh' | 'plain'
    entity: string
    id: number
    data?: {
        [key: string]: any
    }
    iat: Date
    exp: Date
}

const decodeJwtPayload = (token: string): JwtBody | null => {
    const base64Url = token.split('.')[1];
    if (!base64Url) {
        return null;
    }
    try {
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const buff = Buffer.from(base64, 'base64');
        const payload = buff.toString();
        // const payload = new TextDecoder().decode(Uint8Array.from(atob(base64), c => c.charCodeAt(0)));
        const decodedPayload = JSON.parse(payload);
        if (decodedPayload.iat) {
            decodedPayload.iat = new Date(decodedPayload.iat * 1000);
        }
        if (decodedPayload.exp) {
            decodedPayload.exp = new Date(decodedPayload.exp * 1000);
        }
        return decodedPayload;
    } catch (err) {
        return null;
    }
}
export {decodeJwtPayload}
